import { SET_BUSQUEDA_GLOBAL_RESULTADOS } from '../types';

const initialState = {
    resultados: null,
    loading: false
};

export default function busquedaGlobalReducer(state = initialState, action) {
    switch (action.type) {
        case SET_BUSQUEDA_GLOBAL_RESULTADOS:
            return {
                ...state,
                resultados: action.payload,
                loading: false
            };
        default:
            return state;
    }
}
